import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { queryKeys } from '@/lib/query-keys'
import { useWorkspaces } from './useWorkspaces'

export interface ApiActivityLog {
  id: string;
  workspace_id: string;
  endpoint: string;
  method: string;
  status_code: number;
  request_body?: Record<string, any>;
  response_summary?: string;
  user_id?: string;
  api_key_id?: string;
  ip_address?: string;
  user_agent?: string;
  duration_ms: number;
  created_at: string;
}

async function fetchApiActivity(workspaceId: string, limit: number = 100): Promise<ApiActivityLog[]> {
  if (!workspaceId) return [];

  const { data, error } = await supabase
    .from('api_activity_logs')
    .select('*')
    .eq('workspace_id', workspaceId)
    .order('created_at', { ascending: false })
    .limit(limit);

  if (error) {
    console.error('Error fetching API activity:', error);
    throw new Error(error.message);
  }

  return data as ApiActivityLog[];
}

export function useApiActivity(limit: number = 100) {
  const { currentWorkspace } = useWorkspaces();

  return useQuery({
    queryKey: queryKeys.apiActivity.list(currentWorkspace?.id),
    queryFn: () => fetchApiActivity(currentWorkspace!.id, limit),
    enabled: !!currentWorkspace?.id,
    refetchInterval: 30000, // Refetch every 30 seconds
    staleTime: 10000, // Consider data stale after 10 seconds
    gcTime: 1000 * 60 * 5, // Cache for 5 minutes
  });
}
